import React from 'react';
import { AlertCircle } from 'lucide-react';

interface MockNotificationProps {
  useMock?: boolean;
}

export const MockNotification: React.FC<MockNotificationProps> = ({ useMock = true }) => {
  if (useMock) {
    return (
      <div className="fixed bottom-8 right-8 bg-amber-50 border border-amber-200 rounded-lg p-4 max-w-md shadow-lg">
        <div className="flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-medium text-amber-900">Using Mock Data</p>
            <p className="text-sm text-amber-700 mt-1">
              Azure OpenAI not configured or API call failed. Create a .env file with your credentials.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};